<template>
    <div class="max-height overflow-auto center">
        <ion-grid>
            <ion-row>
                <ion-col class="center flex-d-c px-4">
                    <img class="card-border" style="max-height: 300px" v-if="cartData?.supplier?.imageLink" alt=""
                         :src="(cartData?.supplier?.imageLink.startsWith('/')) ? `https://app.octopusorder.com${cartData?.supplier?.imageLink}` : cartData?.supplier?.imageLink"/>
                    <ion-icon v-else icon="assets/icon/logo.svg" class="octo-logo coral-coral-color fs-28"/>
                </ion-col>
            </ion-row>

            <ion-row class="pb-3 pt-5">
                <ion-col class="fs-22 fw-600 ion-text-center octo-gradient-purple-color">
                    {{ $t('messages.order.sent', { target: cartData.supplier.name ?? 'ihren Lieferanten' }) }}
                </ion-col>
            </ion-row>

            <ion-row class="pb-3">
                <ion-col class="center">
                    <button-fix
                        :color="ION_VARIANT.CORAL"
                        class="light-light-color light-medium-shadow"
                        @click="$emit('next')"
                    >
                        {{ $t('button.ok') }}
                    </button-fix>
                </ion-col>
            </ion-row>
        </ion-grid>
    </div>
</template>

<script setup lang="ts">
import { IonGrid, IonRow, IonCol, IonIcon } from "@ionic/vue";

import ButtonFix from "@/components/button/ButtonFix.vue";

import { ION_VARIANT } from "@/types/enum/ionicEnum";
import { CartData } from "@/types/supplier";

defineProps<{ cartData: CartData }>()
defineEmits<{ (e: 'next'): void }>()
</script>
